import React from 'react';
import { Typography, Stack } from '@mui/material';
import { NotificationContainer, ContentContainer, CloseButton } from './styles';

import ScoreConfigInfoImg from 'public/assets/img/score-config-info.png';

interface ImportantUpdateNotificationProps {
  onDismiss: () => void;
}

const ImportantUpdateNotification: React.FC<
  ImportantUpdateNotificationProps
> = ({ onDismiss }) => {
  return (
    <NotificationContainer>
      <ContentContainer>
        <img
          src={ScoreConfigInfoImg}
          alt="Score Configuration Info"
          style={{ width: '100px', height: '60px' }}
        />
        <Stack direction="column">
          <Typography className="title">
            Edits Made to Scoring Thresholds
          </Typography>
          <Typography className="description">
            All past scores will be recalculated based on the new thresholds
            you're setting. If you want to preserve your current scoring data,
            please duplicate this template first and make your changes to the
            copy instead.
          </Typography>
        </Stack>
      </ContentContainer>

      <CloseButton
        size="small"
        onClick={onDismiss}
        aria-label="Dismiss notification"
      >
        ✕
      </CloseButton>
    </NotificationContainer>
  );
};

export default ImportantUpdateNotification;
